/* eslint-disable react/prop-types */
import React from 'react';

import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';

import { COLOR_PALETTE, ILLUSTRATION_FILLS, PRIMARY_COLOR } from 'constants/ui';

const IconPropTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

const noShrinkStyles = {
  flexShrink: 0,
};

const useIllustrationFills = () => useTheme().palette.illustration ?? ILLUSTRATION_FILLS;

export const NoContentIcon = () => {
  const fills = useIllustrationFills();

  return (
    <svg fill="none" height="41" viewBox="0 0 59 41" width="59" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="29.5" cy="37.0197" fill={fills.shadow} rx="29" ry="3.98062" />
      <path
        clipRule="evenodd"
        d="M14.9772 5H44.0228C44.9542 5 45.8328 5.43261 46.4007 6.17087L54.8779 17.1912C55.2813 17.7157 55.5 18.3587 55.5 19.0204V35C55.5 36.6569 54.1569 38 52.5 38H6.5C4.84315 38 3.5 36.6569 3.5 35V19.0204C3.5 18.3587 3.71872 17.7157 4.12213 17.1912L12.5993 6.17087C13.1672 5.43261 14.0458 5 14.9772 5Z"
        fill={fills.surface}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M35 31C35.8284 31 36.5 31.6716 36.5 32.5C36.5 33.3284 35.8284 34 35 34H24C23.1716 34 22.5 33.3284 22.5 32.5C22.5 31.6716 23.1716 31 24 31H35ZM43.5 7C44.1295 7 44.7223 7.29639 45.1 7.8L52.3 17.4C52.6314 17.8418 52.5418 18.4686 52.1 18.8C51.9269 18.9298 51.7164 19 51.5 19H46C45.7239 19 45.5 19.2239 45.5 19.5V24C45.5 25.6569 44.1569 27 42.5 27H16.5C14.8431 27 13.5 25.6569 13.5 24V19.5C13.5 19.2239 13.2761 19 13 19H7.5C6.94772 19 6.5 18.5523 6.5 18C6.5 17.7836 6.57018 17.5731 6.7 17.4L13.9 7.8C14.2777 7.29639 14.8705 7 15.5 7H43.5Z"
        fill={fills.inner}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M21 0.5C21 0.223858 20.7761 0 20.5 0C20.2239 0 20 0.223858 20 0.5V1.5H19C18.7239 1.5 18.5 1.72386 18.5 2C18.5 2.27614 18.7239 2.5 19 2.5H20V3.5C20 3.77614 20.2239 4 20.5 4C20.7761 4 21 3.77614 21 3.5V2.5H22C22.2761 2.5 22.5 2.27614 22.5 2C22.5 1.72386 22.2761 1.5 22 1.5H21V0.5ZM46.4007 6.17087C45.8328 5.43261 44.9542 5 44.0228 5H14.9772C14.0458 5 13.1672 5.43261 12.5993 6.17087L4.12213 17.1912C3.71872 17.7157 3.5 18.3587 3.5 19.0204V35C3.5 36.6569 4.84315 38 6.5 38H52.5C54.1569 38 55.5 36.6569 55.5 35V19.0204C55.5 18.3587 55.2813 17.7157 54.8779 17.1912L46.4007 6.17087ZM14.9772 6H44.0228C44.6437 6 45.2295 6.28841 45.608 6.78058L54.0852 17.8009C54.3542 18.1506 54.5 18.5793 54.5 19.0204V35C54.5 36.1046 53.6046 37 52.5 37H6.5C5.39543 37 4.5 36.1046 4.5 35V19.0204C4.5 18.5793 4.64582 18.1506 4.91475 17.8009L13.392 6.78058C13.7361 6.33315 14.2515 6.05412 14.8089 6.00709L14.9772 6ZM35 31C35.8284 31 36.5 31.6716 36.5 32.5C36.5 33.3284 35.8284 34 35 34H24C23.1716 34 22.5 33.3284 22.5 32.5C22.5 31.6716 23.1716 31 24 31H35ZM24 32H35C35.2761 32 35.5 32.2239 35.5 32.5C35.5 32.7761 35.2761 33 35 33H24C23.7239 33 23.5 32.7761 23.5 32.5C23.5 32.2239 23.7239 32 24 32ZM43.5 7C44.1295 7 44.7223 7.29639 45.1 7.8L52.3 17.4C52.6314 17.8418 52.5418 18.4686 52.1 18.8C51.9269 18.9298 51.7164 19 51.5 19H46C45.7239 19 45.5 19.2239 45.5 19.5V24C45.5 25.6569 44.1569 27 42.5 27H16.5C14.8431 27 13.5 25.6569 13.5 24V19.5C13.5 19.2239 13.2761 19 13 19H7.5C6.94772 19 6.5 18.5523 6.5 18C6.5 17.7836 6.57018 17.5731 6.7 17.4L13.9 7.8C14.2777 7.29639 14.8705 7 15.5 7H43.5ZM15.5 8H43.5C43.8148 8 44.1111 8.14819 44.3 8.4L51.5 18H46C45.1716 18 44.5 18.6716 44.5 19.5V24C44.5 25.1046 43.6046 26 42.5 26H16.5C15.3954 26 14.5 25.1046 14.5 24V19.5C14.5 18.6716 13.8284 18 13 18H7.5L14.7 8.4C14.8889 8.14819 15.1852 8 15.5 8ZM38 19C38.2761 19 38.5 19.2239 38.5 19.5V20H39C39.2761 20 39.5 20.2239 39.5 20.5C39.5 20.7761 39.2761 21 39 21H38.5V21.5C38.5 21.7761 38.2761 22 38 22C37.7239 22 37.5 21.7761 37.5 21.5V21H37C36.7239 21 36.5 20.7761 36.5 20.5C36.5 20.2239 36.7239 20 37 20H37.5V19.5C37.5 19.2239 37.7239 19 38 19Z"
        fill={fills.stroke}
        fillRule="evenodd"
      />
    </svg>
  );
};

export const NoResultsIcon = () => {
  const fills = useIllustrationFills();

  return (
    <svg fill="none" height="60" viewBox="0 0 80 60" width="80" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M66.0329 48.0083C66.0329 50.2128 53.9373 52 39.0165 52C24.0957 52 12 50.2128 12 48.0083C12 45.8037 24.0957 44.0165 39.0165 44.0165C53.9373 44.0165 66.0329 45.8037 66.0329 48.0083Z"
        fill={fills.shadow}
      />
      <path
        clipRule="evenodd"
        d="M50.5185 42L39.0185 53H38.065C37.4095 53 36.7862 52.6837 36.4655 52.112C36.2537 51.7345 36.0539 51.317 36.0185 51.0335C35.9384 50.3926 36.5185 49 36.5185 49L47.0185 38.5C47.0185 38.5 45.5185 35.3201 45.5185 33C45.5185 27.201 50.2195 22.5 56.0185 22.5C61.8175 22.5 66.5185 27.201 66.5185 33C66.5185 38.799 61.8175 43.5 56.0185 43.5C53.6984 43.5 50.5185 42 50.5185 42ZM20.0819 16.5C19.5055 16.5 19.0484 16.0139 19.0838 15.4386L19.2802 12.2481L22.375 11.3652L23.0715 8.5L36.0185 8.66676L36.5185 11.5L56.8716 11.6124C57.9303 11.6183 58.801 12.4481 58.8577 13.5052L58.9619 15.4464C58.9927 16.0189 58.5367 16.5 57.9634 16.5H20.0819ZM56.0185 41.5C60.7129 41.5 64.5185 37.6944 64.5185 33C64.5185 28.3056 60.7129 24.5 56.0185 24.5C51.3241 24.5 47.5185 28.3056 47.5185 33C47.5185 37.6944 51.3241 41.5 56.0185 41.5Z"
        fill={fills.inner}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M58.2158 16.5C59.0092 16.5 60.4247 17.0421 61.1162 17.3281C61.3745 17.4349 61.5689 17.6509 61.6573 17.9161L61.9509 18.7971C61.9955 18.9309 61.6525 22.6604 61.6525 22.6604C61.5969 23.217 61.1005 23.6231 60.5439 23.5674C60.4494 23.558 55.8812 22.5343 55.615 22.6009C55.615 22.6009 53.3617 22.9623 52.2791 23.3467C51.2938 23.6965 47.2176 27.2512 47.2176 27.2512C47.0857 27.416 45.5344 31.6589 45.565 31.9643C45.565 31.9643 46.8133 38.7053 46.5089 39.0097L39.1901 46.3284C38.44 47.0786 37.4226 47.5 36.3617 47.5H22.1399C20.8665 47.5 19.642 47.0258 18.7026 46.1751L16.0186 19C16.3426 18.0278 16.9815 17.1914 17.8341 16.6229L58.2158 16.5ZM54.9577 43.1723C55.858 43.2639 58.8807 43.1564 58.9761 43.1723C59.4819 43.2566 59.8354 43.7068 59.8106 44.2069L58.8239 47.1339C58.6676 47.2902 45.9659 47.4473 45.8721 47.3536C45.6985 47.18 50.0089 42.5097 50.0089 42.5097C50.1552 42.3634 51.3333 42.8033 54.9577 43.1723Z"
        fill={fills.surface}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M17.5186 7.5V6.5C17.5186 6.22386 17.7424 6 18.0186 6C18.2947 6 18.5186 6.22386 18.5186 6.5V7.5H19.5186C19.7947 7.5 20.0186 7.72386 20.0186 8C20.0186 8.27614 19.7947 8.5 19.5186 8.5H18.5186V9.5C18.5186 9.77614 18.2947 10 18.0186 10C17.7424 10 17.5186 9.77614 17.5186 9.5V8.5H16.5186C16.2424 8.5 16.0186 8.27614 16.0186 8C16.0186 7.72386 16.2424 7.5 16.5186 7.5H17.5186ZM62.0186 51V50.5C62.0186 50.2239 62.2425 50 62.5186 50C62.7947 50 63.0186 50.2239 63.0186 50.5V51H63.5186C63.7947 51 64.0186 51.2239 64.0186 51.5C64.0186 51.7761 63.7947 52 63.5186 52H63.0186V52.5C63.0186 52.7761 62.7947 53 62.5186 53C62.2425 53 62.0186 52.7761 62.0186 52.5V52H61.5186C61.2425 52 61.0186 51.7761 61.0186 51.5C61.0186 51.2239 61.2425 51 61.5186 51H62.0186ZM36.776 48H20.8089C19.2628 48 17.9699 46.825 17.8226 45.2859L15.3332 19.2859C15.1753 17.6366 16.3843 16.1716 18.0336 16.0137C18.1287 16.0046 18.2241 16 18.3195 16H18.4375L18.2909 14.2505C18.1526 12.5994 19.3789 11.1488 21.03 11.0105C21.1133 11.0035 21.1968 11 21.2804 11H22.0186V10C22.0186 8.89543 22.914 8 24.0186 8H35.0186C36.1232 8 37.0186 8.89543 37.0186 10V11H56.7568C58.4136 11 59.7568 12.3431 59.7568 14C59.7568 14.0836 59.7533 14.1672 59.7463 14.2505L59.5997 16H59.7176C61.3745 16 62.7176 17.3431 62.7176 19C62.7176 19.0955 62.7131 19.1909 62.704 19.2859L62.2584 23.9398C65.134 25.924 67.0186 29.2419 67.0186 33C67.0186 37.508 64.3069 41.3826 60.4257 43.0816L60.2146 45.2859C60.0673 46.825 58.7744 48 57.2283 48H45.2612L40.4622 52.799C39.2907 53.9706 37.3912 53.9706 36.2196 52.799C35.048 51.6274 35.048 49.7279 36.2196 48.5564L36.776 48ZM61.3099 23.3539L61.7085 19.1906C61.7146 19.1273 61.7176 19.0636 61.7176 19C61.7176 17.8954 60.8222 17 59.7176 17H18.3195C18.2559 17 18.1923 17.003 18.1289 17.0091C17.0294 17.1144 16.2234 18.0911 16.3286 19.1906L18.818 45.1906C18.9162 46.2167 19.7782 47 20.8089 47H37.776L46.4125 38.3634C45.5247 36.7767 45.0186 34.9475 45.0186 33C45.0186 26.9249 49.9435 22 56.0186 22C57.9366 22 59.74 22.4909 61.3099 23.3539ZM46.2612 47H57.2283C58.259 47 59.1209 46.2167 59.2192 45.1906L59.3834 43.4759C58.3228 43.8162 57.1922 44 56.0186 44C54.0711 44 52.2419 43.4939 50.6551 42.6061L46.2612 47ZM19.441 16H58.5962L58.7498 14.167C58.7544 14.1114 58.7568 14.0557 58.7568 14C58.7568 12.8954 57.8613 12 56.7568 12H36.0186V10C36.0186 9.44772 35.5709 9 35.0186 9H24.0186C23.4663 9 23.0186 9.44772 23.0186 10V12H21.2804C21.2247 12 21.169 12.0023 21.1135 12.007C20.0127 12.0992 19.1952 13.0663 19.2874 14.167L19.441 16ZM49.7835 42.0635C48.6773 41.301 47.7176 40.3413 46.9551 39.2351L36.9267 49.2635C36.1457 50.0445 36.1457 51.3108 36.9267 52.0919C37.7078 52.8729 38.9741 52.8729 39.7551 52.0919L49.7835 42.0635ZM56.0186 43C61.5414 43 66.0186 38.5228 66.0186 33C66.0186 27.4772 61.5414 23 56.0186 23C50.4957 23 46.0186 27.4772 46.0186 33C46.0186 38.5228 50.4957 43 56.0186 43ZM56.0186 42C51.048 42 47.0186 37.9706 47.0186 33C47.0186 28.0294 51.048 24 56.0186 24C60.9892 24 65.0186 28.0294 65.0186 33C65.0186 37.9706 60.9892 42 56.0186 42ZM56.0186 41C60.4369 41 64.0186 37.4183 64.0186 33C64.0186 28.5817 60.4369 25 56.0186 25C51.6003 25 48.0186 28.5817 48.0186 33C48.0186 37.4183 51.6003 41 56.0186 41ZM62.0228 30.506C62.1288 30.761 62.0081 31.0536 61.7531 31.1596C61.4981 31.2657 61.2054 31.1449 61.0994 30.8899C61.0273 30.7164 60.9463 30.5469 60.8567 30.3818C60.7251 30.1391 60.8151 29.8355 61.0578 29.7039C61.3006 29.5722 61.6041 29.6623 61.7358 29.905C61.8416 30.1002 61.9374 30.3008 62.0228 30.506ZM60.6448 28.434C60.8387 28.6305 60.8367 28.9471 60.6402 29.1411C60.4436 29.3351 60.1271 29.333 59.9331 29.1365C59.3697 28.5658 58.6885 28.1234 57.9368 27.8436C57.678 27.7473 57.5462 27.4594 57.6426 27.2006C57.7389 26.9418 58.0268 26.8101 58.2856 26.9064C59.1745 27.2372 59.9795 27.76 60.6448 28.434Z"
        fill={fills.stroke}
        fillRule="evenodd"
      />
    </svg>
  );
};

export const NoEntitiesFoundIcon = () => {
  const fills = useIllustrationFills();

  return (
    <svg fill="none" height="60" viewBox="0 0 80 60" width="80" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="40" cy="55" fill={fills.shadow} rx="22" ry="2.5" />
      <rect
        fill={fills.inner}
        height="9"
        rx="4.5"
        stroke={fills.stroke}
        strokeWidth="1.5"
        transform="rotate(45 45.73 39.73)"
        width="20"
        x="45.73"
        y="35.23"
      />
      <circle cx="33" cy="27" fill={fills.inner} r="18" stroke={fills.stroke} strokeWidth="1.8" />
      <circle cx="33" cy="27" fill={fills.surface} r="13" />
      <rect fill={fills.stroke} height="4" rx="2" width="18" x="24" y="25" />
    </svg>
  );
};

export const TemporaryFileIcon = ({ color = PRIMARY_COLOR, height = 17, width = 14 }) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 14 17"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66797 1V4.33333C8.66797 4.55435 8.75577 4.76631 8.91205 4.92259C9.06833 5.07887 9.28029 5.16667 9.5013 5.16667H12.8346"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.168 16H2.83464C2.39261 16 1.96868 15.8244 1.65612 15.5118C1.34356 15.1993 1.16797 14.7754 1.16797 14.3333V2.66667C1.16797 2.22464 1.34356 1.80072 1.65612 1.48816C1.96868 1.17559 2.39261 1 2.83464 1H8.66797L12.8346 5.16667V14.3333C12.8346 14.7754 12.659 15.1993 12.3465 15.5118C12.0339 15.8244 11.61 16 11.168 16Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.66797 10.1693C3.66797 11.0533 4.01916 11.9012 4.64428 12.5263C5.2694 13.1514 6.11725 13.5026 7.0013 13.5026C7.88536 13.5026 8.7332 13.1514 9.35832 12.5263C9.98345 11.9012 10.3346 11.0533 10.3346 10.1693C10.3346 9.28522 9.98345 8.43737 9.35832 7.81225C8.7332 7.18713 7.88536 6.83594 7.0013 6.83594C6.11725 6.83594 5.2694 7.18713 4.64428 7.81225C4.01916 8.43737 3.66797 9.28522 3.66797 10.1693Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 8.91406V10.1674L7.83333 11.0007"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

TemporaryFileIcon.propTypes = {
  ...IconPropTypes,
};

export const BorrowerTabIcon = ({ size = 20, ...props }) => (
  <svg
    fill="currentColor"
    height={size}
    viewBox="0 0 20 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2.14453 13.5706V14.0813C2.14453 16.7377 5.15239 18.5706 9.28739 18.5706C9.53025 18.5701 9.76906 18.5632 10.0038 18.5499L10.0017 18.5277V17.4763C9.76882 17.4911 9.53072 17.4987 9.28739 17.4992C5.63667 17.4992 3.21596 15.9913 3.21596 14.0813V13.5706L3.22096 13.467C3.2467 13.202 3.37017 12.9561 3.56731 12.7772C3.76446 12.5983 4.02116 12.4992 4.28739 12.4992H11.566L12.8238 11.4277H4.28739C3.71907 11.4277 3.17402 11.6535 2.77216 12.0554C2.3703 12.4572 2.14453 13.0023 2.14453 13.5706ZM9.28739 9.99916C9.8502 9.99916 10.4075 9.88831 10.9275 9.67293C11.4474 9.45755 11.9199 9.14187 12.3178 8.74391C12.7158 8.34594 13.0315 7.87349 13.2469 7.35352C13.4622 6.83355 13.5731 6.27626 13.5731 5.71345C13.5731 5.15064 13.4622 4.59334 13.2469 4.07338C13.0315 3.55341 12.7158 3.08096 12.3178 2.68299C11.9199 2.28503 11.4474 1.96934 10.9275 1.75396C10.4075 1.53859 9.8502 1.42773 9.28739 1.42773C8.15075 1.42773 7.06066 1.87926 6.25693 2.68299C5.4532 3.48672 5.00167 4.57681 5.00167 5.71345C5.00167 6.85009 5.4532 7.94018 6.25693 8.74391C7.06066 9.54763 8.15075 9.99916 9.28739 9.99916ZM9.28739 2.49916C10.1399 2.49916 10.9574 2.83781 11.5602 3.44061C12.163 4.0434 12.5017 4.86097 12.5017 5.71345C12.5017 6.56593 12.163 7.3835 11.5602 7.98629C10.9574 8.58909 10.1399 8.92773 9.28739 8.92773C8.43491 8.92773 7.61734 8.58909 7.01455 7.98629C6.41175 7.3835 6.0731 6.56593 6.0731 5.71345C6.0731 4.86097 6.41175 4.0434 7.01455 3.44061C7.61734 2.83781 8.43491 2.49916 9.28739 2.49916ZM14.0088 11.3606C14.1865 11.2098 14.4119 11.127 14.6449 11.127C14.8779 11.127 15.1033 11.2098 15.281 11.3606L18.2274 13.8649C18.4467 14.0513 18.5731 14.3249 18.5731 14.6134V18.5299C18.5731 18.947 18.2345 19.2856 17.8174 19.2856H16.8281C16.6278 19.2852 16.4358 19.2055 16.2941 19.0638C16.1525 18.9222 16.0728 18.7302 16.0724 18.5299V16.3184C16.0724 16.1587 16.0091 16.0054 15.8964 15.8922C15.7837 15.7789 15.6307 15.7149 15.471 15.7142H13.8174C13.6576 15.7147 13.5045 15.7787 13.3917 15.892C13.279 16.0052 13.2158 16.1586 13.216 16.3184V18.5299C13.216 18.947 12.8774 19.2856 12.4602 19.2856H11.471C11.2706 19.2852 11.0786 19.2055 10.937 19.0638C10.7954 18.9222 10.7156 18.7302 10.7152 18.5299V14.6134C10.7152 14.3256 10.8417 14.052 11.061 13.8649L14.0074 11.3606H14.0088Z" />
  </svg>
);

export const FeesTabIcon = ({ size = 20, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(3 2) scale(1.18)">
      <path
        d="M5 0C4.46957 0 3.96086 0.210714 3.58579 0.585786C3.21071 0.960859 3 1.46957 3 2V7.207C3.3269 7.11458 3.66167 7.05265 4 7.022V2C4 1.73478 4.10536 1.48043 4.29289 1.29289C4.48043 1.10536 4.73478 1 5 1H9V4.5C9 4.89782 9.15804 5.27936 9.43934 5.56066C9.72064 5.84196 10.1022 6 10.5 6H14V14C14 14.2652 13.8946 14.5196 13.7071 14.7071C13.5196 14.8946 13.2652 15 13 15H9.4C9.21802 15.3562 8.99771 15.6916 8.743 16H13C13.5304 16 14.0391 15.7893 14.4142 15.4142C14.7893 15.0391 15 14.5304 15 14V5.414C14.9997 5.01631 14.8414 4.63503 14.56 4.354L10.646 0.439C10.3648 0.157982 9.98355 8.48813e-05 9.586 0H5ZM13.793 5H10.5C10.3674 5 10.2402 4.94732 10.1464 4.85355C10.0527 4.75979 10 4.63261 10 4.5V1.207L13.793 5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.42"
      />
      <path
        clipRule="evenodd"
        d="M9 12.5C9 13.6935 8.52589 14.8381 7.68198 15.682C6.83807 16.5259 5.69347 17 4.5 17C3.30653 17 2.16193 16.5259 1.31802 15.682C0.474106 14.8381 0 13.6935 0 12.5C0 11.3065 0.474106 10.1619 1.31802 9.31802C2.16193 8.47411 3.30653 8 4.5 8C5.69347 8 6.83807 8.47411 7.68198 9.31802C8.52589 10.1619 9 11.3065 9 12.5ZM6.54943 10.4506C6.51212 10.4133 6.46782 10.3836 6.41907 10.3634C6.37031 10.3433 6.31806 10.3329 6.26529 10.3329C6.21251 10.3329 6.16026 10.3433 6.1115 10.3634C6.06275 10.3836 6.01845 10.4133 5.98114 10.4506L2.45057 13.9811C2.41326 14.0185 2.38366 14.0628 2.36346 14.1115C2.34327 14.1603 2.33288 14.2125 2.33288 14.2653C2.33288 14.3181 2.34327 14.3703 2.36346 14.4191C2.38366 14.4678 2.41326 14.5121 2.45057 14.5494C2.48789 14.5867 2.53218 14.6163 2.58094 14.6365C2.62969 14.6567 2.68194 14.6671 2.73471 14.6671C2.78748 14.6671 2.83974 14.6567 2.88849 14.6365C2.93724 14.6163 2.98154 14.5867 3.01886 14.5494L6.54943 11.0189C6.58675 10.9815 6.61635 10.9372 6.63655 10.8885C6.65675 10.8397 6.66715 10.7875 6.66715 10.7347C6.66715 10.6819 6.65675 10.6297 6.63655 10.5809C6.61635 10.5322 6.58675 10.4879 6.54943 10.4506ZM3.08764 10.3336C2.88739 10.3336 2.69535 10.4131 2.55375 10.5547C2.41216 10.6963 2.33261 10.8884 2.33261 11.0886C2.33261 11.2889 2.41216 11.4809 2.55375 11.6225C2.69535 11.7641 2.88739 11.8436 3.08764 11.8436C3.28789 11.8436 3.47994 11.7641 3.62153 11.6225C3.76313 11.4809 3.84268 11.2889 3.84268 11.0886C3.84268 10.8884 3.76313 10.6963 3.62153 10.5547C3.47994 10.4131 3.28789 10.3336 3.08764 10.3336ZM5.91236 13.1576C5.71211 13.1576 5.52006 13.2372 5.37847 13.3788C5.23687 13.5204 5.15732 13.7124 5.15732 13.9127C5.15732 14.1129 5.23687 14.305 5.37847 14.4466C5.52006 14.5882 5.71211 14.6677 5.91236 14.6677C6.1126 14.6677 6.30465 14.5882 6.44625 14.4466C6.58784 14.305 6.66739 14.1129 6.66739 13.9127C6.66739 13.7124 6.58784 13.5204 6.44625 13.3788C6.30465 13.2372 6.1126 13.1576 5.91236 13.1576Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

export const CheckedCheckbox = props => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_8762_360158)">
      <rect fill="currentColor" height="16" width="16" />
      <path d="M4.57031 7.2407L7.61793 10.2883L12.5703 5.33594" stroke="white" strokeWidth="2" />
    </g>
    <defs>
      <clipPath id="clip0_8762_360158">
        <rect fill="white" height="16" rx="4" width="16" />
      </clipPath>
    </defs>
  </svg>
);

export const Checkbox = props => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect height="15" rx="3.5" stroke="#999999" width="15" x="0.5" y="0.5" />
  </svg>
);

const getListArrowStyles = ({ isExpanded }) => ({
  transform: isExpanded ? 'none' : 'rotate(180deg)',
  transition: 'transform 0.2s ease',
});

export const ListArrow = ({ isExpanded, ...props }) => (
  <svg
    fill="none"
    height="6"
    style={getListArrowStyles({ isExpanded })}
    viewBox="0 0 8 6"
    width="8"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7 4.5L4 1.5L1 4.5" stroke={COLOR_PALETTE.GRAY[8]} strokeWidth="2" />
  </svg>
);

export const IconCalendarClosed = props => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 17 16"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    style={noShrinkStyles}
  >
    <path
      d="M13.668 2.125H12.043V1.5C12.043 1.40054 12.0035 1.30516 11.9331 1.23483C11.8628 1.16451 11.7674 1.125 11.668 1.125C11.5685 1.125 11.4731 1.16451 11.4028 1.23483C11.3325 1.30516 11.293 1.40054 11.293 1.5V2.125H6.04297V1.5C6.04297 1.40054 6.00346 1.30516 5.93313 1.23483C5.86281 1.16451 5.76742 1.125 5.66797 1.125C5.56851 1.125 5.47313 1.16451 5.4028 1.23483C5.33248 1.30516 5.29297 1.40054 5.29297 1.5V2.125H3.66797C3.4359 2.125 3.21334 2.21719 3.04925 2.38128C2.88516 2.54538 2.79297 2.76794 2.79297 3V13C2.79297 13.2321 2.88516 13.4546 3.04925 13.6187C3.21334 13.7828 3.4359 13.875 3.66797 13.875H13.668C13.9 13.875 14.1226 13.7828 14.2867 13.6187C14.4508 13.4546 14.543 13.2321 14.543 13V3C14.543 2.76794 14.4508 2.54538 14.2867 2.38128C14.1226 2.21719 13.9 2.125 13.668 2.125ZM3.66797 2.875H5.29297V3.5C5.29297 3.59946 5.33248 3.69484 5.4028 3.76517C5.47313 3.83549 5.56851 3.875 5.66797 3.875C5.76742 3.875 5.86281 3.83549 5.93313 3.76517C6.00346 3.69484 6.04297 3.59946 6.04297 3.5V2.875H11.293V3.5C11.293 3.59946 11.3325 3.69484 11.4028 3.76517C11.4731 3.83549 11.5685 3.875 11.668 3.875C11.7674 3.875 11.8628 3.83549 11.9331 3.76517C12.0035 3.69484 12.043 3.59946 12.043 3.5V2.875H13.668C13.7011 2.875 13.7329 2.88817 13.7564 2.91161C13.7798 2.93505 13.793 2.96685 13.793 3V5.125H3.54297V3C3.54297 2.96685 3.55614 2.93505 3.57958 2.91161C3.60302 2.88817 3.63482 2.875 3.66797 2.875ZM13.668 13.125H3.66797C3.63482 13.125 3.60302 13.1118 3.57958 13.0884C3.55614 13.0649 3.54297 13.0332 3.54297 13V5.875H13.793V13C13.793 13.0332 13.7798 13.0649 13.7564 13.0884C13.7329 13.1118 13.7011 13.125 13.668 13.125ZM10.433 8.265L9.19797 9.5L10.433 10.735C10.4698 10.7693 10.4994 10.8107 10.5199 10.8567C10.5404 10.9027 10.5514 10.9524 10.5523 11.0027C10.5532 11.0531 10.5439 11.1031 10.525 11.1498C10.5062 11.1965 10.4781 11.2389 10.4425 11.2745C10.4069 11.3101 10.3645 11.3382 10.3178 11.3571C10.2711 11.3759 10.2211 11.3852 10.1707 11.3843C10.1204 11.3834 10.0707 11.3724 10.0247 11.3519C9.9787 11.3314 9.9373 11.3018 9.90297 11.265L8.66797 10.03L7.43297 11.265C7.36188 11.3312 7.26786 11.3673 7.17071 11.3656C7.07356 11.3639 6.98086 11.3245 6.91216 11.2558C6.84345 11.1871 6.8041 11.0944 6.80238 10.9973C6.80067 10.9001 6.83673 10.8061 6.90297 10.735L8.13797 9.5L6.90297 8.265C6.86613 8.23067 6.83657 8.18927 6.81608 8.14327C6.79558 8.09727 6.78456 8.04761 6.78367 7.99726C6.78278 7.94691 6.79205 7.8969 6.81091 7.8502C6.82977 7.80351 6.85784 7.76109 6.89345 7.72548C6.92906 7.68987 6.97148 7.6618 7.01817 7.64294C7.06486 7.62408 7.11488 7.61482 7.16523 7.6157C7.21558 7.61659 7.26524 7.62761 7.31124 7.64811C7.35724 7.66861 7.39864 7.69816 7.43297 7.735L8.66797 8.97L9.90297 7.735C9.9373 7.69816 9.9787 7.66861 10.0247 7.64811C10.0707 7.62761 10.1204 7.61659 10.1707 7.6157C10.2211 7.61482 10.2711 7.62408 10.3178 7.64294C10.3645 7.6618 10.4069 7.68987 10.4425 7.72548C10.4781 7.76109 10.5062 7.80351 10.525 7.8502C10.5439 7.8969 10.5532 7.94691 10.5523 7.99726C10.5514 8.04761 10.5404 8.09727 10.5199 8.14327C10.4994 8.18927 10.4698 8.23067 10.433 8.265Z"
      fill="currentColor"
    />
  </svg>
);

export const CheckIcon = props => (
  <svg
    fill="none"
    height="20"
    viewBox="0 0 21 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M10.375 0C4.85215 0 0.375 4.47715 0.375 10C0.375 15.5228 4.85215 20 10.375 20C15.8978 20 20.375 15.5228 20.375 10C20.375 4.47715 15.8978 0 10.375 0ZM15.5821 7.70711C15.9726 7.31658 15.9726 6.68342 15.5821 6.29289C15.1916 5.90237 14.5584 5.90237 14.1679 6.29289L8.875 11.5858L6.58211 9.29289C6.19158 8.90237 5.55842 8.90237 5.16789 9.29289C4.77737 9.68342 4.77737 10.3166 5.16789 10.7071L8.16789 13.7071C8.55842 14.0976 9.19158 14.0976 9.58211 13.7071L15.5821 7.70711Z"
      fill="#039855"
      fillRule="evenodd"
    />
  </svg>
);

export const CheckOutlinedIcon = props => (
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM15.2071 6.29289C15.5976 6.68342 15.5976 7.31658 15.2071 7.70711L9.20711 13.7071C8.81658 14.0976 8.18342 14.0976 7.79289 13.7071L4.79289 10.7071C4.40237 10.3166 4.40237 9.68342 4.79289 9.29289C5.18342 8.90237 5.81658 8.90237 6.20711 9.29289L8.5 11.5858L13.7929 6.29289C14.1834 5.90237 14.8166 5.90237 15.2071 6.29289Z"
      fill="#039855"
      fillRule="evenodd"
    />
  </svg>
);

export const ErrorIcon = props => (
  <svg
    fill="none"
    height="20"
    viewBox="0 0 21 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M10.375 0C4.85215 0 0.375 4.47715 0.375 10C0.375 15.5228 4.85215 20 10.375 20C15.8978 20 20.375 15.5228 20.375 10C20.375 4.47715 15.8978 0 10.375 0ZM8.08211 6.29289C7.69158 5.90237 7.05842 5.90237 6.66789 6.29289C6.27737 6.68342 6.27737 7.31658 6.66789 7.70711L8.96079 10L6.66789 12.2929C6.27737 12.6834 6.27737 13.3166 6.66789 13.7071C7.05842 14.0976 7.69158 14.0976 8.08211 13.7071L10.375 11.4142L12.6679 13.7071C13.0584 14.0976 13.6916 14.0976 14.0821 13.7071C14.4726 13.3166 14.4726 12.6834 14.0821 12.2929L11.7892 10L14.0821 7.70711C14.4726 7.31658 14.4726 6.68342 14.0821 6.29289C13.6916 5.90237 13.0584 5.90237 12.6679 6.29289L10.375 8.58579L8.08211 6.29289Z"
      fill="#D92D20"
      fillRule="evenodd"
    />
  </svg>
);

export const ErrorOutlinedIcon = props => (
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L10 8.58579L12.2929 6.29289C12.6834 5.90237 13.3166 5.90237 13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711L11.4142 10L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L10 11.4142L7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071C5.90237 13.3166 5.90237 12.6834 6.29289 12.2929L8.58579 10L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289Z"
      fill="#D92D20"
      fillRule="evenodd"
    />
  </svg>
);

export const WarningIcon = props => (
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM11 6C11 5.44772 10.5523 5 10 5C9.44771 5 9 5.44772 9 6V10.5C9 11.0523 9.44771 11.5 10 11.5C10.5523 11.5 11 11.0523 11 10.5V6ZM11 13.9688C11 13.4165 10.5523 12.9688 10 12.9688C9.44771 12.9688 9 13.4165 9 13.9688V14C9 14.5523 9.44771 15 10 15C10.5523 15 11 14.5523 11 14V13.9688Z"
      fill="#FDB022"
      fillRule="evenodd"
    />
  </svg>
);

export const InfoIcon = props => (
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M10.0001 1.66669C5.39771 1.66669 1.66675 5.39765 1.66675 10C1.66675 14.6024 5.39771 18.3334 10.0001 18.3334C14.6025 18.3334 18.3334 14.6024 18.3334 10C18.3334 5.39765 14.6025 1.66669 10.0001 1.66669ZM10.8334 6.66669C10.8334 6.20645 10.4603 5.83335 10.0001 5.83335C9.53984 5.83335 9.16675 6.20645 9.16675 6.66669V6.68553C9.16675 7.14577 9.53984 7.51886 10.0001 7.51886C10.4603 7.51886 10.8334 7.14577 10.8334 6.68553V6.66669ZM9.58341 8.75002C9.12318 8.75002 8.75008 9.12312 8.75008 9.58335C8.75008 9.8918 8.91766 10.1611 9.16675 10.3052V12.5C8.70651 12.5 8.33341 12.8731 8.33341 13.3334C8.33341 13.7936 8.70651 14.1667 9.16675 14.1667H10.8334C11.2937 14.1667 11.6667 13.7936 11.6667 13.3334C11.6667 12.8731 11.2937 12.5 10.8334 12.5V10C10.8334 9.30966 10.2738 8.75002 9.58341 8.75002Z"
      fill={COLOR_PALETTE.BLUE[7]}
      fillRule="evenodd"
    />
  </svg>
);
